import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
export function PricingSection() {
  return <Section id="pricing" background="warm" className="text-center" data-id="element-127">
      <div className="max-w-2xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-orange-100" data-id="element-128">
        <div className="bg-stone-900 text-white py-3 px-6" data-id="element-129">
          <p className="text-xs font-medium tracking-wider uppercase text-orange-200" data-id="element-130">
            Oferta Especial
          </p>
        </div>

        <div className="p-6 md:p-8 space-y-6" data-id="element-131">
          <div data-id="element-132">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-stone-900 mb-1" data-id="element-133">
              Puentes de Palabras
            </h2>
            <p className="text-stone-500 text-sm" data-id="element-134">
              El sistema completo + bonos
            </p>
          </div>

          <div className="space-y-2" data-id="element-135">
            <div className="flex items-center justify-center gap-3" data-id="element-136">
              <span className="text-xl text-stone-400 line-through" data-id="element-137">
                $19.99
              </span>
              <span className="bg-red-500 text-white px-2 py-0.5 rounded-full text-xs font-bold" data-id="element-138">
                68% OFF
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-139">
              <span className="text-4xl font-bold text-stone-900" data-id="element-140">$6.39</span>
              <span className="text-stone-500 text-lg self-end mb-1" data-id="element-141">USD</span>
            </div>
          </div>

          <div className="space-y-3" data-id="element-142">
            <Button size="lg" className="w-full text-base h-14 shadow-orange-200 shadow-lg" href="https://narelaspace.com/cart/47494784745692:1" data-id="element-143">
              Comprar y empezar hoy
            </Button>
            <p className="text-xs text-stone-400 flex items-center justify-center gap-1" data-id="element-144">
              <Lock size={12} data-id="element-145" /> Pago seguro y encriptado
            </p>
          </div>

          <div className="pt-6 border-t border-stone-100" data-id="element-146">
            <p className="text-stone-600 mb-3 font-medium text-sm" data-id="element-147">
              Si quieres dejar de improvisar cada conversación y empezar a
              hablar en un idioma que tus papás sí reciben...
            </p>
            <div className="flex items-center justify-center gap-2 text-xs text-stone-500" data-id="element-148">
              <ShieldCheck className="text-green-600 w-4 h-4" data-id="element-149" />
              <span data-id="element-150">Garantía de satisfacción</span>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}